// src/routes/MeetingEmbedPage.jsx

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MeetingEmbed from '../components/meetings/MeetingEmbed';
import { API } from '../config';

const MeetingEmbedPage = () => {
    const { meetingKey } = useParams();
    const [joinURL, setJoinURL] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (meetingKey) {
            const fetchMeetingDetails = async () => {
                setLoading(true);
                try {
                    // Fetch the full meeting details from your backend using the meetingKey
                    const response = await fetch(`${API.GET_SINGLE_MEETING_ENDPOINT}?meetingKey=${meetingKey}`);
                    const data = await response.json();

                    if (data.success && data.meeting) {
                        setJoinURL(data.meeting.joinLink);
                    } else {
                        setError('Meeting not found or failed to load.');
                    }
                } catch (err) {
                    setError('Failed to fetch meeting data.');
                } finally {
                    setLoading(false);
                }
            };

            fetchMeetingDetails();
        }
    }, [meetingKey]);

    if (loading) {
        return <p>Loading meeting...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div style={{ padding: '20px' }}>
            <h2>Joining Meeting...</h2>
            <MeetingEmbed joinURL={joinURL} />
        </div>
    );
};

export default MeetingEmbedPage;